/* SELVA 2.0 — fri fragt-tæller i annoncebaren (efter Humble Brush) */
(function () {
  var THRESHOLD = 30000; // 300,00 kr i øre
  var ABO_FRI = 27900;   // abonnement med mindst 279 kr i kurven får fri fragt (automatisk rabat "Fri fragt på abonnement (4-pak)")
  var CURRENCY = 'DKK';  // tælleren kører kun på det danske marked

  function kr(cents) {
    var v = (cents / 100);
    var s = (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2).replace('.', ',')) + '';
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr';
  }

  function texts(lang) {
    if (lang === 'en') {
      return {
        base: 'Free shipping over 300 DKK',
        more: function (m) { return 'Add ' + kr(m) + ' more and shipping is free'; },
        done: 'Free shipping unlocked'
      };
    }
    return {
      base: 'Fri fragt over 300 kr',
      more: function (m) { return 'Køb for ' + kr(m) + ' mere og få fri fragt'; },
      done: 'Du har fri fragt'
    };
  }

  function target() {
    var a = document.querySelector('.wt-announcement a[href*="fragtpolitik"]');
    return a || document.querySelector('.wt-announcement .wt-announcement__body');
  }

  function aboFri(cart) {
    if (window.Shopify && Shopify.country && Shopify.country !== 'DK') return false;
    return (cart.items || []).some(function (i) { return !!i.selling_plan_allocation; }) && (cart.total_price || 0) >= ABO_FRI;
  }

  function render(cart) {
    var el = target();
    if (!el || !cart) return;
    if (cart.currency && cart.currency !== CURRENCY) return;
    var t = texts(document.documentElement.lang || 'da');
    var total = cart.total_price || 0;
    if (total <= 0) { el.textContent = t.base; return; }
    if (total >= THRESHOLD || aboFri(cart)) { el.textContent = t.done; return; }
    el.textContent = t.more(THRESHOLD - total);
  }

  var busy = false;
  function refresh() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function watchCart() {
    var badge = document.querySelector('[class*="cart-count"]');
    if (!badge) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(refresh, 350);
    }).observe(badge, { childList: true, subtree: true, characterData: true });
  }

  function boot() {
    refresh();
    watchCart();
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refresh();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* SELVA 2.0 — forsidens gamle bundle-builder: rabat i kroner og pris på knappen */
(function () {
  function parseKr(txt) {
    if (!txt) return null;
    var m = txt.replace(/[^\d.,]/g, '').replace(/\./g, '').replace(',', '.');
    var v = parseFloat(m);
    return isNaN(v) ? null : v;
  }
  function fmtKr(v) {
    var s = v.toFixed(2).replace('.', ',');
    var parts = s.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts.join(',') + ' kr';
  }
  function enhance(root) {
    var totalEl = root.querySelector('[data-bundle-total]');
    var cta = root.querySelector('[data-bundle-cta]');
    if (!totalEl || !cta) return;
    var pct = parseFloat(root.getAttribute('data-discount-percentage') || '0');
    var countEl = root.querySelector('[data-bundle-count]');
    var counts = (countEl && countEl.textContent.match(/(\d+)\s*\/\s*(\d+)/)) || null;
    var count = counts ? parseInt(counts[1], 10) : 0;
    var min = counts ? parseInt(counts[2], 10) : 0;
    var sEl = totalEl.querySelector('s');
    var saleEl = totalEl.querySelector('.price-item--sale');
    var orig = parseKr(sEl ? sEl.textContent : '');
    var disc = parseKr(saleEl ? saleEl.textContent : totalEl.textContent);
    var row = totalEl.parentElement;
    if (row && row.parentElement) {
      var saved = row.parentElement.querySelector('.wt-bundle__saved');
      if (!saved) {
        saved = document.createElement('div');
        saved.className = 'wt-bundle__saved';
        row.insertAdjacentElement('afterend', saved);
      }
      if (orig && disc && orig > disc) {
        saved.textContent = 'Du sparer ' + fmtKr(orig - disc);
        saved.hidden = false;
      } else { saved.hidden = true; }
    }
    var label = cta.querySelector('span');
    if (label) {
      if (!cta.disabled && disc) label.textContent = 'Læg i kurv · ' + fmtKr(disc);
      else if (min) label.textContent = 'Vælg ' + min + ' varer';
    }
    var more = root.querySelector('[data-bundle-status-more]');
    var got = root.querySelector('[data-bundle-status-discount]');
    var info = root.querySelector('[data-bundle-info]');
    var missing = Math.max(0, min - count);
    if (got) got.textContent = 'Du sparer ' + pct + '% på hele pakken';
    if (more) {
      if (missing > 0 && count > 0) {
        more.textContent = 'Tilføj ' + missing + (missing === 1 ? ' vare' : ' varer') + ' mere og spar ' + pct + '%';
        more.removeAttribute('hidden');
      } else { more.setAttribute('hidden', ''); }
    }
    if (info) info.removeAttribute('hidden');
  }
  function init() {
    document.querySelectorAll('bundle-builder').forEach(function (root) {
      var run = function () { try { enhance(root); } catch (e) {} };
      run();
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 30); }).observe(root, { childList: true, subtree: true, characterData: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* SELVA 2.0 — abo-fordele i kurven (19.10.2026): gratis fragt og gaver, vist som en boks over regnestykket.
   Ligger her og ikke i selva-kurv.js, som kun tegner linjer og totaler. Observerer kurvens linjer og lægger boksen ovenpå.
   Fri fragt-delen spejler den automatiske Shopify-rabat "Fri fragt på abonnement (4-pak)" (kun abonnement, kun DK, mindst 279 kr). */
(function () {
  var GAVE_PRODUKTER = ['horse-bristle-toothbrush-4-pak'];
  var ABO_FRI = 27900;

  var css = '' +
    '.skv__gave{display:none !important}' +
    '.skv__fordele{margin:0;padding:12px 14px;border-radius:10px;background:#F2EDE6}' +
    '.skv__fordele-titel{margin:0 0 9px;font-size:13px;font-weight:600;color:#1D2E1F}' +
    '.skv__fordele ul{list-style:none;margin:0;padding:0;display:grid;gap:8px}' +
    '.skv__fordele li{display:flex;align-items:center;gap:9px;font-size:13.5px;line-height:1.3;color:#1D2E1F}' +
    '.skv__fordele li svg{flex:0 0 auto;width:16px;height:16px;color:#3E5B42}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var CHECK = "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='M4 12.5l5.2 5.2L20 7'></path></svg>";

  function dk(cart) {
    if (cart.currency && cart.currency !== 'DKK') return false;
    if (window.Shopify && Shopify.country && Shopify.country !== 'DK') return false;
    return true;
  }

  function opdater(cart) {
    var rod = document.querySelector('[data-skv]');
    if (!rod || !cart) return;
    var tal = rod.querySelector('.skv__tal');
    if (!tal) return;
    var items = cart.items || [];
    var gave = items.some(function (i) { return i.selling_plan_allocation && GAVE_PRODUKTER.indexOf(i.handle) !== -1; });
    var fri = dk(cart) && items.some(function (i) { return !!i.selling_plan_allocation; }) && (cart.total_price || 0) >= ABO_FRI;
    var box = rod.querySelector('[data-skv-fordele]');
    if (!gave) {
      if (box) box.hidden = true;
    } else {
      if (!box) {
        box = document.createElement('div');
        box.className = 'skv__fordele';
        box.setAttribute('data-skv-fordele', '');
        tal.parentNode.insertBefore(box, tal);
      }
      var li = '';
      if (fri) li += '<li>' + CHECK + 'Gratis fragt</li>';
      li += '<li>' + CHECK + 'Gratis tungeskraber i levering 2</li>';
      li += '<li>' + CHECK + 'Gratis tandtråd i levering 4</li>';
      box.innerHTML = '<p class="skv__fordele-titel">Med abonnement får du</p><ul>' + li + '</ul>';
      box.hidden = false;
    }
    var fragt = rod.querySelector('[data-skv-fragt]');
    var val = rod.querySelector('[data-skv-fragt-vaerdi]');
    if (fri) {
      if (fragt && gave) fragt.hidden = true;
      if (val) { val.textContent = 'Gratis'; val.classList.add('er-gratis'); }
    }
  }

  var travl = false;
  function hent() {
    if (travl) return;
    travl = true;
    fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(opdater)
      .catch(function () {})
      .then(function () { travl = false; });
  }

  function start() {
    var tries = 0;
    var t = setInterval(function () {
      var linjer = document.querySelector('[data-skv-linjer]');
      if (!linjer) { if (++tries > 40) clearInterval(t); return; }
      clearInterval(t);
      new MutationObserver(function () { setTimeout(hent, 0); }).observe(linjer, { childList: true });
      hent();
    }, 250);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
